<template>
  <div class="survey-wrapper-z-index">
    <SanitasSurvey
      v-if="surveyConfig"
      :key="surveyConfig.randomKey"
      :language="surveyConfig.language"
      :touch-point="surveyConfig.touchPoint"
      :partner-number="surveyConfig.partnerNumber"
      :survey-name="surveyConfig.surveyName"
      :basket-id="surveyConfig.basketId"
      :content-id="surveyConfig.contentId"
      @survey-initialised="openPrompt"
    >
      <Prompt :show="showPrompt" />
      <div class="survey">
        <SurveyModal :show="surveyStarted" />
      </div>
    </SanitasSurvey>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import Prompt from '../components/common/Prompt'
import SurveyModal from '../components/common/SurveyModal'
import SanitasSurvey from '../components/common/SanitasSurvey'

const { mapActions, mapGetters } = createNamespacedHelpers('survey')

export default {
  name: 'SanitasSurveyWeb',

  components: {
    Prompt,
    SurveyModal,
    SanitasSurvey,
  },
  data() {
    return {
      surveyConfig: null,
    }
  },
  created() {
    window.addEventListener(
      'sanitas_survey-trigger_event',
      ({ detail: surveyConfig }) => {
        const survey = window.Sanitas.survey
        const now = Date.now()
        const oneHour = 3600000

        const startTimeLocalStorage =
          window.localStorage[`sanSurvey_${surveyConfig.touchPoint}_started`]
        const startTime = parseInt(survey.blockTimeStarted)
        const isStartTimeDifferenceTooSmall =
          now - parseInt(startTimeLocalStorage) < startTime * oneHour

        const completeTimeLocalStorage =
          window.localStorage[`sanSurvey_${surveyConfig.touchPoint}_completed`]
        const completeTime = parseInt(survey.blockTimeCompleted)
        const isCompleteTimeDifferenceTooSmall =
          now - parseInt(completeTimeLocalStorage) < completeTime * oneHour

        if (
          (startTimeLocalStorage &&
            startTime &&
            isStartTimeDifferenceTooSmall) ||
          (completeTimeLocalStorage &&
            completeTime &&
            isCompleteTimeDifferenceTooSmall)
        ) {
          return
        }

        const language = !surveyConfig.language &&
          survey.language && { language: survey.language }

        const contentId = !surveyConfig.contentId &&
          survey.contentId && { contentId: survey.contentId }

        const partnerNumber = surveyConfig.vepaNr && {
          partnerNumber: surveyConfig.vepaNr,
        }

        this.surveyConfig = {
          ...surveyConfig,
          ...language,
          ...contentId,
          ...partnerNumber,
          randomKey: now,
        }
      },
    )

    if (window.Sanitas.survey.triggerBehavior === 'immediate') {
      window.setTimeout(function () {
        window.dispatchEvent(
          new CustomEvent('sanitas_survey-trigger_event', {
            detail: {
              language: window.Sanitas.survey.lang,
              touchPoint: window.Sanitas.survey.touchpointId,
            },
          }),
        )
      }, 1000)
    } else if (window.Sanitas.survey.triggerBehavior === 'simpletimeout') {
      window.setTimeout(function () {
        window.dispatchEvent(
          new CustomEvent('sanitas_survey-trigger_event', {
            detail: {
              language: window.Sanitas.survey.lang,
              touchPoint: window.Sanitas.survey.touchpointId,
            },
          }),
        )
      }, parseInt(window.Sanitas.survey.triggerTimeout1) * 1000)
    } else if (window.Sanitas.survey.triggerBehavior === 'scrolltimeout') {
      window.Sanitas.survey.scrollTrigger = {
        waitForScroll: true,
        waitForPage: true,
        scrollHandler: function () {
          if (
            window.pageYOffset > 50 ||
            document.body.clientHeight -
              window.pageYOffset -
              window.innerHeight <
              200
          ) {
            window.removeEventListener(
              'scroll',
              window.Sanitas.survey.scrollTrigger.scrollHandler,
            )
            window.setTimeout(function () {
              if (!window.Sanitas.survey.scrollTrigger.waitForPage) {
                window.dispatchEvent(
                  new CustomEvent('sanitas_survey-trigger_event', {
                    detail: {
                      language: window.Sanitas.survey.lang,
                      touchPoint: window.Sanitas.survey.touchpointId,
                    },
                  }),
                )
              } else {
                window.Sanitas.survey.scrollTrigger.waitForScroll = false
              }
            }, parseInt(window.Sanitas.survey.triggerTimeout2) * 1000)
          }
        },
      }
      if (
        document.body.clientHeight - window.pageYOffset - window.innerHeight <
        200
      ) {
        window.Sanitas.survey.scrollTrigger.waitForScroll = false
      } else {
        window.addEventListener(
          'scroll',
          window.Sanitas.survey.scrollTrigger.scrollHandler,
        )
      }
      window.setTimeout(function () {
        if (!window.Sanitas.survey.scrollTrigger.waitForScroll) {
          window.dispatchEvent(
            new CustomEvent('sanitas_survey-trigger_event', {
              detail: {
                language: window.Sanitas.survey.lang,
                touchPoint: window.Sanitas.survey.touchpointId,
              },
            }),
          )
        } else {
          window.Sanitas.survey.scrollTrigger.waitForPage = false
        }
      }, parseInt(window.Sanitas.survey.triggerTimeout1) * 1000)
    }
  },
  computed: {
    ...mapGetters(['showPrompt', 'surveyStarted']),
  },
  methods: {
    ...mapActions(['openPrompt']),
  },
}
</script>

<style scoped lang="postcss">
@import '../css/global.css';
.survey-wrapper-z-index {
  position: relative;
  z-index: 999;
}

@media (max-width: 410px) {
  .survey >>> .modal-container {
    height: 100vh;
  }
}

.radio .form-input {
  margin-right: 30px !important;
}
</style>
